module.exports = __webpack_public_path__ + "img/logo2-2.4e69d80d.png";